import { useEffect, useState } from "react";
import { KeyboardArrowDown } from "@mui/icons-material";
import { Link } from "react-router-dom";
import {
  Agent_Header_Icon,
  Agentic_Header_Icon,
  AI_Academy_Icon,
  AI_Core_Icon,
  Analytics_Engine_Header_Icon,
  Article_Header_Icon,
  Capital_Market_Icon,
  Career_Header_Icon,
  Contact_Header_icon,
  DA_Header_Icon,
  Enterprises_Header_Icon,
  Event_Header_Icon,
  FAQs_Header_Icon,
  Financial_Header_Icon,
  Infrastructure_Header_Icon,
  Logo,
  Partnership_Icon,
  PLM_Header_Icon,
  Team_Header_Icon,
  Trade_Icon,
} from "../../assets";
import Hambuger from "../hamburger";
import { headerDropdown } from "./constants";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useModal } from "../../utils/demoProvider";
import { useNavigate } from "react-router-dom";

export const NewHeader = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [navbarBackground, setNavbarBackground] = useState("dark");
  const { openModal } = useModal();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = window.scrollY;
      const heroSectionHeight = 0;

      if (scrollHeight > heroSectionHeight) {
        setNavbarBackground("dark");
      } else {
        setNavbarBackground("transparent");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setToggleMenu(false);
  }, []);

  // Lock page scroll while the mobile menu slider is open.
  useEffect(() => {
    if (!toggleMenu) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [toggleMenu]);

  return (
    <div className={`z-[1000] fixed w-screen top-[1px] md:top-5`}>
      <nav
        className={` ${
          navbarBackground === "transparent"
            ? "bg-[#0000000A] border border-[#FFFFFF12]"
            : "bg-[#010127]/80 backdrop-blur-xl border border-[#FFFFFF12] shadow-lg shadow-black/20"
        } container mx-auto w-full flex justify-between py-2 xl:p-0 rounded-[100px]`}
      >
        <div className="flex w-full justify-between mx-3 xl:py-1">
          <Link to="/" className="flex items-start">
            <img src={Logo} alt="logo" className="h-[58px]" />
          </Link>
          <div className="hidden lg:flex ">
            {/* Platforms */}
            <div className="relative group py-6">
              <button
                type="button"
                className="flex gap-0.5 xl:gap-1 items-center focus:outline-none px-2 xl:px-6"
              >
                <p className="font-medium text-[15px] text-white group-hover:text-poppingBlue transition-colors duration-300 ease-out">
                  Platforms
                </p>
                <KeyboardArrowDown className="text-white" />
              </button>

              <div
                className="
                absolute top-full left-0 lg:-left-[20px] xl:left-2 lg:w-[70vw] xl:w-[60vw] max-w-[1022px]
                bg-white shadow-xl p-8 justify-between gap-4 rounded-xl
                opacity-0 translate-y-2 pointer-events-none
                group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto
                transition-all duration-300 ease-out
                flex
                "
              >
                {/* Left section */}
                <div className="flex justify-between gap-[24px]">
                  <div className="flex flex-col gap-8 basis-2/4">
                    <h1 className="font-bold text-[18px]">Analytics</h1>

                    <div className="flex flex-col gap-[24px]">
                      <Link to="/ai-platform">
                        <div className="flex gap-4">
                          <img
                            src={Agentic_Header_Icon}
                            alt="ai platform icon"
                          />
                          <div>
                            <h5 className="font-bold">[AI] Platform</h5>
                            <p className="text-sm text-[#737373]">
                              Orchestration of agents for enterprise
                              decision-making.
                            </p>
                          </div>
                        </div>
                      </Link>

                      <Link to="/pulse">
                        <div className="flex gap-4">
                          <img src={PLM_Header_Icon} alt="plm icon" />
                          <div>
                            <h5 className="font-bold">Pulse</h5>
                            <p className="text-sm text-[#737373]">
                              Give your AI the context it needs
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="flex flex-col gap-8 basis-2/4">
                    <h1 className="font-bold text-[18px]">Intelligence</h1>

                    <div className="flex flex-col gap-[24px]">
                      <Link to="/core">
                        <div className="flex gap-4">
                          <img src={AI_Core_Icon} alt="plm icon" />
                          <div>
                            <h5 className="font-bold">CORE</h5>
                            <p className="text-sm text-[#737373]">
                              AI that doesn't just answer, it reasons
                            </p>
                          </div>
                        </div>
                      </Link>

                      <Link to="/data-assistant">
                        <div className="flex gap-4">
                          <img src={DA_Header_Icon} alt="data assistant icon" />
                          <div>
                            <h5 className="font-bold">Data Assistant</h5>
                            <p className="text-sm text-[#737373]">
                              An enterprise AI agent for analytics, delivering
                              explainable insights.
                            </p>
                          </div>
                        </div>
                      </Link>

                      <Link to="/tradetutor">
                        <div className="flex gap-4">
                          <img src={Trade_Icon} alt="trade tutor icon" />
                          <div>
                            <h5 className="font-bold">TradeTutor</h5>
                            <p className="text-sm text-[#737373]">
                              Private fine-tuned models for analytics, keeping
                              enterprise data secure.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Solutions */}
            <div className="relative group py-6">
              <button
                type="button"
                className="flex gap-0.5 xl:gap-1 items-center focus:outline-none  px-2 xl:px-6"
              >
                <p className="font-medium text-[15px] text-white group-hover:text-poppingBlue transition-colors duration-300 ease-out">
                  Solutions
                </p>
                <KeyboardArrowDown className="text-white" />
              </button>

              <div
                className="
                  absolute top-full left-0 lg:-left-[10px] xl:left-1 lg:w-[45vw] xl:w-[35vw]
                  bg-white shadow-xl p-8 justify-between rounded-xl
                  opacity-0 translate-y-2 pointer-events-none
                  group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto
                  transition-all duration-300 ease-out
                  flex
                "
              >
                {/* Left Section */}
                <div className="flex flex-col gap-[24px]">
                  <Link to="/solutions/capital-markets">
                    <div className="flex gap-4">
                      <img
                        src={Capital_Market_Icon}
                        alt="for enterprise icon"
                        className="!w-[42px] !h-[42px]"
                      />
                      <div>
                        <h5 className="font-bold">For Capital Markets</h5>
                        <p className="text-sm text-[#737373]">
                          Empowering Investment Decisions with Intelligent LLMs
                          and Real-Time Analytics Agents
                        </p>
                      </div>
                    </div>
                  </Link>

                  <Link to="/solutions/financial-markets">
                    <div className="flex gap-4">
                      <img
                        src={Financial_Header_Icon}
                        alt="for financial institutions icon"
                      />
                      <div>
                        <h5 className="font-bold">For Financial Markets</h5>
                        <p className="text-sm text-[#737373]">
                          Targeted insights and retail trader engagement.
                        </p>
                      </div>
                    </div>
                  </Link>

                  <Link to="/solutions/enterprises">
                    <div className="flex gap-4">
                      <img
                        src={Enterprises_Header_Icon}
                        alt="digital analytics header icon"
                      />
                      <div>
                        <h5 className="font-bold">For Enterprises</h5>
                        <p className="text-sm text-[#737373]">
                          Becoming data-driven with secure LLMs and analytics
                          agents.
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* Technology */}
            <div className="relative group py-6">
              <button
                type="button"
                className="flex gap-0.5 xl:gap-1 items-center focus:outline-none px-2 xl:px-6"
              >
                <p className="font-medium text-[15px] text-white group-hover:text-poppingBlue transition-colors duration-300 ease-out">
                  Technology
                </p>
                <KeyboardArrowDown className="text-white" />
              </button>

              {/* Animated Dropdown */}
              <div
                className="absolute top-full left-0 lg:-left-[0px] xl:left-4
               lg:w-[26vw] bg-white rounded-xl p-8 justify-between
               opacity-0 scale-95 translate-y-2 pointer-events-none 
               transition-all duration-300 ease-out 
               group-hover:opacity-100 group-hover:scale-100 group-hover:translate-y-0 group-hover:pointer-events-auto flex"
              >
                {/* Left Column */}
                <div className="flex flex-col gap-[24px]">
                  <Link to="/technology#infrastructure">
                    <div className="flex gap-4">
                      <img
                        src={Infrastructure_Header_Icon}
                        alt="Infrastructure Header Icon"
                      />
                      <div>
                        <h5 className="font-bold">Infrastructure</h5>
                        <p className="text-sm text-[#737373]">
                          Private fine-tuned models, secure hosting, compliance
                        </p>
                      </div>
                    </div>
                  </Link>

                  <Link to="/technology#analytics-engine">
                    <div className="flex gap-4">
                      <img
                        src={Analytics_Engine_Header_Icon}
                        alt="Analytics Engine Header Icon"
                      />
                      <div>
                        <h5 className="font-bold">Analytics Engine</h5>
                        <p className="text-sm text-[#737373]">
                          Built for explainability, precision and scale.
                        </p>
                      </div>
                    </div>
                  </Link>

                  <Link to="/technology#agent-framework">
                    <div className="flex gap-4">
                      <img src={Agent_Header_Icon} alt="Agent Header Icon" />
                      <div>
                        <h5 className="font-bold">Agent Framework</h5>
                        <p className="text-sm text-[#737373]">
                          Plug-and-play deployment of analytics-driven AI
                          agents.
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* Resources */}
            <div className="relative group py-6">
              <button
                type="button"
                className="flex gap-0.5 xl:gap-1 items-center focus:outline-none px-2 xl:px-6"
              >
                <p className="font-medium text-[15px] text-white group-hover:text-poppingBlue transition-colors duration-300 ease-out">
                  Resources
                </p>
                <KeyboardArrowDown className="text-white" />
              </button>

              <div
                className="
                  absolute top-full lg:-left-[30px] xl:left-0 lg:w-max
                bg-white p-8 gap-8 rounded-xl
                  opacity-0 scale-95 pointer-events-none
                  group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto
                  transition-all duration-300 ease-out
                  "
              >
                <div className="flex-1 flex flex-col gap-4">
                  <Link to="/blog">
                    <div className="flex gap-4 items-center">
                      <img
                        src={Article_Header_Icon}
                        alt="Article header icon"
                      />
                      <div>
                        <h5 className="font-bold">
                          Articles, Blogs, Whitepapers
                        </h5>
                      </div>
                    </div>
                  </Link>

                  <Link to="/event/ai-data-stack-connect-2025">
                    <div className="flex gap-4 items-center">
                      <img src={Event_Header_Icon} alt="Event header icon" />
                      <div>
                        <h5 className="font-bold">Events & Webinars</h5>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* About Us (last one, aligned left-0) */}
            <div className="relative group py-6">
              <button
                type="button"
                className="flex gap-0.5 xl:gap-1 items-center focus:outline-none px-2 xl:px-6"
              >
                <p className="font-medium text-[15px] text-white group-hover:text-poppingBlue transition-colors duration-300 ease-out">
                  Company
                </p>
                <KeyboardArrowDown className="text-white" />
              </button>

              {/* Animated Dropdown */}
              <div
                className="absolute top-full lg:-left-[30px] xl:left-0 
               w-max bg-white rounded-xl p-8 gap-8 flex flex-col
               opacity-0 scale-95 translate-y-2 pointer-events-none
               transition-all duration-300 ease-out
               group-hover:opacity-100 group-hover:scale-100 group-hover:translate-y-0 group-hover:pointer-events-auto"
              >
                <div className="flex-1 grid grid-cols-2 gap-y-4 gap-x-8">
                  <Link to="/about-us">
                    <div className="flex gap-4 items-center">
                      <img src={Team_Header_Icon} alt="Team header icon" />
                      <div>
                        <h5 className="font-bold">About us</h5>
                      </div>
                    </div>
                  </Link>

                  <Link to="/partners">
                    <div className="flex gap-4 items-center">
                      <img src={Partnership_Icon} alt="Team header icon" />
                      <div>
                        <h5 className="font-bold">Partners</h5>
                      </div>
                    </div>
                  </Link>

                  <a href="https://www.myacademy.ai" target="_blank">
                    <div className="flex gap-4 items-center">
                      <img src={AI_Academy_Icon} alt="Team header icon" />
                      <div>
                        <h5 className="font-bold">[AI] Academy</h5>
                      </div>
                    </div>
                  </a>

                  <Link to="/careers">
                    <div className="flex gap-4 items-center">
                      <img src={Career_Header_Icon} alt="career header icon" />
                      <div>
                        <h5 className="font-bold">Careers</h5>
                      </div>
                    </div>
                  </Link>

                  <Link to="/faqs">
                    <div className="flex gap-4 items-center">
                      <img src={FAQs_Header_Icon} alt="FAQs header icon" />
                      <div>
                        <h5 className="font-bold">FAQs</h5>
                      </div>
                    </div>
                  </Link>

                  <Link to="/contact">
                    <div className="flex gap-4 items-center">
                      <img
                        src={Contact_Header_icon}
                        alt="Contact header icon"
                      />
                      <div>
                        <h5 className="font-bold">Contact</h5>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={openModal}
              className="hidden md:block w-[118px] rounded-[100px] py-3 text-[#010127] btn-sweep btn-sweep-white font-semibold text-center px-3 text-sm md:ml-2"
            >
              Book a Demo
            </button>

            <div className="relative group">
              <button className="hidden md:flex justify-center items-end gap-1 w-[118px] rounded-[100px] py-3 text-white btn-sweep btn-sweep-blue font-semibold text-center px-3 text-sm md:ml-2">
                <span>Login</span>
                <KeyboardArrowDown
                  fontSize="small"
                  className="text-white !w-auto"
                />
              </button>
              <div
                className="absolute top-[45px] lg:top-[40px] lg:-left-[30px] xl:left-0 
               w-max flex flex-col
               opacity-0 scale-95 translate-y-2 pointer-events-none
               transition-all duration-300 ease-out
               group-hover:opacity-100 group-hover:scale-100 group-hover:translate-y-0 group-hover:pointer-events-auto"
              >
                <div className="bg-white flex-1 flex flex-col gap-1 py-0 mt-6">
                  <a
                    href="https://dataassistant.ai/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-base font-bold hover:bg-[#f4f4f4] px-4 py-2 transition-colors duration-200 ease-in"
                  >
                    Data Assistant
                  </a>
                  <a
                    href="https://www.londonstockexchange.com/personal-investing/tools/tradetutor-strategy-simulator"
                    target="_blank"
                    rel="noreferrer"
                    className="text-base font-bold hover:bg-[#f4f4f4] px-4 py-2 transition-colors duration-200 ease-in"
                  >
                    TradeTutor
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="lg:hidden relative z-[200] px-2 cursor-pointer"
          onClick={() => setToggleMenu((prev) => !prev)}
          title="menu"
        >
          <Hambuger isOpen={toggleMenu} />
        </button>
        {toggleMenu && (
          <div
            className={`xl:hidden ${
              toggleMenu
                ? "opacity-100 translate-x-0"
                : "opacity-0 -translate-x-full"
            } transition-all flex-col items-start px-3 w-full left-0 right-0 bg-white shadow-xl fixed z-[200] top-[4.5rem] duration-1000 h-[95vh] overflow-y-auto`} // 👈 key changes
          >
            <div className="w-full ">
              {headerDropdown.map((link, i) => (
                <Accordion
                  key={i}
                  disableGutters
                  elevation={0}
                  square
                  sx={{
                    borderBottom: "1px solid #e0e0e0",
                    "&:before": {
                      display: "none",
                    },
                    "&:last-of-type": {
                      borderBottom: 0,
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${i}-content`}
                    id={`panel${i}-header`}
                  >
                    <span>{link.label}</span>
                  </AccordionSummary>
                  {link.label === "Platforms" ? (
                    <AccordionDetails>
                      <div className="flex flex-col gap-4 mb-4">
                        <h1 className="font-bold text-[16px]">Analytics</h1>
                        <div className="flex flex-col gap-3 flex-1">
                          {link.lists.slice(0, 2).map((list, idx) => (
                            <div
                              onClick={() => {
                                setToggleMenu((prev) => !prev);
                                navigate(list.link);
                              }}
                              key={idx}
                            >
                              <div
                                key={idx}
                                className="flex items-center gap-4"
                              >
                                <img
                                  src={list.icon}
                                  className="w-[42px]"
                                  alt={`${list.text}`}
                                />
                                <div
                                  className={`flex flex-col ${
                                    list.title && list.text
                                      ? "justify-between"
                                      : "justify-center"
                                  }`}
                                >
                                  {list.title && (
                                    <h5 className="text-[#2E2E37] text-sm font-bold">
                                      {list.title}
                                    </h5>
                                  )}
                                  {list.text && (
                                    <p className="text-xs">{list.text}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="flex flex-col gap-3 ">
                        <h1 className="font-bold text-[16px]">Intelligence</h1>
                        <div className="flex flex-col gap-4 flex-1">
                          {link.lists.slice(2).map((list, idx) => (
                            <div
                              onClick={() => {
                                setToggleMenu((prev) => !prev);
                                navigate(list.link);
                              }}
                              key={idx}
                            >
                              <div
                                key={idx}
                                className="flex items-center gap-4"
                              >
                                <img
                                  src={list.icon}
                                  className="w-[42px]"
                                  alt={`${list.text}`}
                                />
                                <div
                                  className={`flex flex-col ${
                                    list.title && list.text
                                      ? "justify-between"
                                      : "justify-center"
                                  }`}
                                >
                                  {list.title && (
                                    <h5 className="text-[#2E2E37] text-sm font-bold">
                                      {list.title}
                                    </h5>
                                  )}
                                  {list.text && (
                                    <p className="text-xs">{list.text}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </AccordionDetails>
                  ) : (
                    <AccordionDetails>
                      <div className="flex flex-col gap-4 flex-1">
                        {link.lists.map((list, idx) => (
                          <div
                            onClick={() => {
                              setToggleMenu((prev) => !prev);
                              navigate(list.link);
                            }}
                            key={idx}
                          >
                            <div key={idx} className="flex items-center gap-4">
                              <img
                                src={list.icon}
                                className="w-[42px]"
                                alt={`${list.text}`}
                              />
                              <div
                                className={`flex flex-col ${
                                  list.title && list.text
                                    ? "justify-between"
                                    : "justify-center"
                                }`}
                              >
                                {list.title && (
                                  <h5 className="text-[#2E2E37] text-sm font-bold">
                                    {list.title}
                                  </h5>
                                )}
                                {list.text && (
                                  <p className="text-xs">{list.text}</p>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </AccordionDetails>
                  )}
                </Accordion>
              ))}

              {/* Login — same external links as the desktop dropdown */}
              <Accordion
                disableGutters
                elevation={0}
                square
                sx={{
                  borderBottom: "1px solid #e0e0e0",
                  "&:before": {
                    display: "none",
                  },
                  "&:last-of-type": {
                    borderBottom: 0,
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel-login-content"
                  id="panel-login-header"
                >
                  <span>Login</span>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="flex flex-col gap-1 flex-1">
                    <a
                      href="https://dataassistant.ai/"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => setToggleMenu(false)}
                      className="text-base font-bold hover:bg-[#f4f4f4] px-4 py-2 transition-colors duration-200 ease-in"
                    >
                      Data Assistant
                    </a>
                    <a
                      href="https://www.londonstockexchange.com/personal-investing/tools/tradetutor-strategy-simulator"
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => setToggleMenu(false)}
                      className="text-base font-bold hover:bg-[#f4f4f4] px-4 py-2 transition-colors duration-200 ease-in"
                    >
                      TradeTutor
                    </a>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};
